import { IconProps } from '@/components/Icons/types/IconInterface';
import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';
import ChevronLeftSvg from '@/assets/ChevronLeft.svg';

const ChevronLeftIcon = ({ size, variant, className }: IconProps) => {
  return (
    <img
      src={ChevronLeftSvg}
      className={cn(iconVariant({ variant, size, className }))}
      aria-hidden="true"
      alt=""
    />
  );
};

export default ChevronLeftIcon;
